import React, { useEffect, useState } from "react";
import { Table, Input, Select } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { toast } from "react-toastify";
import AddEmployeerComponent from "./AddEmployeerComponent";
import { deleteEmployeerComponent, fetchEmployeerComponent } from "./store/employeerComponentSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const { Option } = Select;

const EmployeerComponentDataTable = ({ data, loading }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedComponents, setSelectedComponents] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState(""); // State for debounced search input

  const dispatch = useDispatch();

  const { successMessage, error } = useSelector(
    (state) => state.employeerComponentData
  );

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
    }
    if (error) {
      toast.error(error);
    }
  }, [successMessage, error]);

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchFilteredData();
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Clear timeout on input change
    };
  }, [debouncedSearch, selectedComponents]);

  const fetchFilteredData = () => {
    const filterData = {
      search: debouncedSearch,
      selectedComponents,
    };
    dispatch(fetchEmployeerComponent(filterData));
  };

  const handleDelete = (employeeId) => {
    dispatch(deleteEmployeerComponent(employeeId));
    setDeleteModalOpen(false);
  };

  const handleSearch = (e) => {
    setDebouncedSearch(e.target.value); // Update debounced search state
  };

  const handleSelectChange = (values) => {
    setSelectedComponents(values); // Update selected components state
  };

  const columns = [
    {
      title: "Employee Code",
      dataIndex: "employee_code",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
    {
      title: "Component Name",
      dataIndex: ["components", "component_name"],
    },
    {
      title: "Action",
      render: (text, record) => (
        <div className="text-start">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-delete-${record.id}`}>Delete</Tooltip>
            }
          >
            <Link
              className="btn btn-icon btn-danger btn-sm"
              to="#"
              onClick={() => {
                setSelectedEmployeeId(record.id);
                setDeleteModalOpen(true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#e74c3c",
                color: "#fff",
                fontSize: "18px",
                border: "none",
              }}
            >
              <i className="fa fa-trash" />
            </Link>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="d-flex justify-content-end mb-4">
          <Select
            mode="multiple"
            style={{ width: 200, marginRight: "20px" }}
            placeholder="Select Components"
            onChange={handleSelectChange}
            value={selectedComponents}
          >
            {data.components?.map((component) => (
              <Option key={component.component_name} value={component.component_name}>
                {component.component_name}
              </Option>
            ))}
          </Select>
          <Input
            placeholder="Search Component, Emp Code, Emp Name"
            style={{ width: 200 }}
            onChange={handleSearch}
          />
        </div>
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={data.employee_components}
            loading={loading}
            rowKey="id"
            pagination={{
              pageSize: 10,
              showSizeChanger: false,
            }}
          />
          {isModalOpen && (
            <AddEmployeerComponent
              show={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedEmployeeId}
            />
          )}

          {deleteModalOpen && (
            <DeleteModal
              onConfirm={() => handleDelete(selectedEmployeeId)}
              onCancel={() => setDeleteModalOpen(false)}
              Name="EmployeerComponent"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeerComponentDataTable;
